import theme from '../themes/default'

export default {
  wrap: {
    'margin-left': '18px',
    'margin-right': '18px',
    'margin-top': '-55px',
    '& ul': {
      padding: '0',
      margin: '0',
    },
    '& .am-activity-indicator': {
      background: '#fff',
      position: 'absolute',
      padding: '8px 5px',
      borderRadius: '5px',
      width: '42px',
      margin: '20% auto 0',
      left: '0',
      right: '0',
      'text-align': 'center',
    },
  },
  'item-wrap': {
    '& > div': {
      float: 'left',
      // 'height': '35px',
      'line-height': '25px',
      '&:first-child': {
        width: '60%',
        'padding-top': '3px',
      },
      '&:last-child': {
        width: '40%',
      },
    },
  },
  'item-dish-history-wrap': {
    'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
    'margin-bottom': '20px',
    'border-top-left-radius': '15px',
    'border-top-right-radius': '15px',
    'border-bottom-left-radius': '15px',
    'border-bottom-right-radius': '15px',
    '& > div:nth-child(2)': {
      'border-bottom': 'none !important',
      'padding-bottom': '0 !important',
    },
  },
  'item-dish-history': {
    padding: '15px 0px 10px 0px !important',
    'box-shadow': 'none !important',
    background: 'none !important',
    'border-bottom': '1px solid #f5f5f5 !important',
    '&:last-child': {
      'border-bottom': 'none !important',
      '& > div:nth-child(2)': {
        'border-bottom': 'none !important',
        'padding-bottom': '0 !important',
      },
    },
  },
  'item-dish-wrap': {
    'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
  },
  'item-dish': {
    background: '#fff',
    'list-style-type': 'none',
    padding: '15px 15px 0px 25px',
    // 'border-bottom': '1px solid #e2e2e2',
    position: 'relative',
    '&:first-child': {
      'border-top-right-radius': '15px',
      'border-top-left-radius': '15px',
      'padding-top': '18px',
    },
    '& > div.sub-list:nth-child(2)': {
      'border-bottom': '1px solid #f5f5f5',
      'padding-bottom': '20px',
    },
    '&:last-child': {
      'border-bottom': '0',
      'border-bottom-right-radius': '15px',
      'border-bottom-left-radius': '15px',
      '& > div:nth-child(2)': {
        'border-bottom': 'none',
        'padding-bottom': '20px',
      },
    },
    '& .am-stepper': {
      // 'height': '30px'
    },
    '& .am-stepper-handler-up, .am-stepper-handler-down': {
      borderRadius: '50%',
      border: '2px solid #4A8CA1',
      // 'width': '25px',
      // 'height': '25px',
      // 'line-height': '28px',
      '& .am-icon': {
        color: '#4A8CA1',
        width: '13px',
        height: '13px',
      },
    },
    '& .am-stepper-input-wrap': {
      // 'line-height': '25px'
    },
    '& textarea': {
      width: '100%',
      border: 'none',
      overflow: 'auto',
      outline: 'none',
      '-webkit-box-shadow': 'none',
      '-moz-box-shadow': 'none',
      'box-shadow': 'none',
      resize: 'none',
    },
  },
  'total-qty': {
    'font-weight': '100',
    'font-size': '12px',
    'margin-bottom': '5px',
  },
  'name-dish': {
    'font-size': '16px',
    'font-weight': 'bold',
    'line-height': '1.2',
    'margin-bottom': '5px',
    'margin-right': '5px',
  },
  'total-price': {
    'text-align': 'right',
    'font-weight': 'bold',
    'font-size': '20px',
    color: '#a91d1d',
  },
  'total-price-prefix': {
    'font-size': '12px',
    'margin-right': '3px',
    color: '#614D4A',
    'vertical-align': 'middle',
    display: 'inline-block',
  },
  hidden: {
    display: 'none',
  },
  'total-price-text': {
    display: 'inline-block',
  },
  'require-option': {
    margin: '10px 0 0 0',
  },
  'especial-wrap': {
    'margin-top': '8px',
  },
  'especial-option': {
    '& ul': {
      padding: '0',
      margin: '0',
      '& li': {
        background: '#f9f9f9',
        margin: '5px 0px',
        padding: '12px 15px 12px 15px',
        borderRadius: '5px',
        color: '#549fce',
        'list-style-type': 'none',
        '& div': {
          display: 'inline-block',
          'margin-right': '10px',
          'font-size': '12px',
          '&:after': {
            content: '"、"',
          },
          '&:last-child': {
            '&:after': {
              content: '" "',
            },
          },
        },
      },
    },
  },
  'especial-title': {
    'font-weight': '100',
    'font-size': '12px',
    color: '#614D4A',
  },
  'set-item-options': {
    background: '#f3f3f3',
    margin: '8px !important',
    padding: '5px 0 !important',
    borderRadius: '5px',
    '& li': {
      background: 'none !important',
      padding: '0 15px !important',
    },
  },
  'bg-shape': {
    width: '15px',
    height: '13px',
    position: 'absolute',
    background: '#ffefc2',
    'border-bottom-right-radius': '15px',
    'border-top-right-radius': '15px',
  },
  'bg-shape-checkout': {
    top: '40px',
    left: '0',
  },
  'bg-shape-history': {
    top: '39px',
    left: '-25px',
  },
  'button-group': {
    'margin-top': '10px',
  },
  button: {
    'font-size': '14px',
    'font-weight': 'bold',
    'letter-spacing': '2px',
    'margin-bottom': '5px',
  },
  'basket-empty-message': {
    background: '#fff',
    padding: '12px 15px 15px 30px',
    borderRadius: '5px',
  },
  'history-date-wrap': {
    'margin-bottom': '35px',
  },
  'history-date': {
    color: '#fff',
    width: '130px',
    padding: '5px 0 4px 27px',
    position: 'absolute',
    left: '0',
    'border-top-right-radius': '10px',
    'border-bottom-right-radius': '10px',
    'font-size': '12px',
    '& span': {
      '&:first-child': {
        'margin-right': '10px',
      },
    },
  },
  'history-table-wrap': {
    'text-align': 'right',
    color: '#614D4A',
    'font-size': '16px',
    right: '15px',
  },
  'today-background': {
    background: '#a91d1d',
  },
  'not-today-background': {
    background: '#d9cecc',
  },
  'history-item-date-time': {
    'text-align': 'right',
  },
  'history-item-date-time-title': {
    color: '#A59996',
    'font-size': '14px',
    'letter-spacing': '1px',
    'margin-bottom': '4px',
  },
  'history-item-date': {
    'letter-spacing': '1px',
    'font-weight': 'bold',
    'margin-top': '2px',
  },
  'history-item-time': {
    'letter-spacing': '1px',
    'font-weight': 'bold',
  },
  'history-item-total': {
    'font-size': '14px',
    'letter-spacing': '1px',
    color: '#A59996',
    'text-align': 'right',
  },
  'history-item-price': {
    'font-size': '22px',
    'letter-spacing': '1px',
    color: '#614D4A',
    'font-weight': 'bold',
    'margin-top': '2px',
    '& span': {
      'margin-left': '5px',
    },
  },
  'activity-indicatior-wrap': {
    height: '100%',
    'text-align': 'center',
    'padding-top': '28%',
    '& span': {
      margin: '0 auto',
    },
  },
  'history-item-original-price': {
    'font-size': '18px',
    color: '#a7a7a7',
    'text-decoration': 'line-through',
    display: 'inline-block',
    'margin-right': '5px',
  },
  'history-price-total-element-prefix': {
    display: 'inline-block',
    'vertical-align': 'middle',
    'font-size': '14px',
    'margin-right': '2px',
    height: '22px',
    color: '#757575',
  },
  'history-price-total-element-text': {
    display: 'inline-block',
  },
  'history-item-discount-price': {
    display: 'inline-block',
  },
  'history-item-discount-price-prefix': {
    display: 'inline-block',
    'font-size': '14px',
    'vertical-align': 'middle',
    height: '24px',
    'margin-right': '2px',
  },
  'history-item-discount-price-text': {
    display: 'inline-block',
  },
  'history-item-original-price-prefix': {
    display: 'inline-block',
    'font-size': '12px',
    'vertical-align': 'middle',
    height: '19px',
    'margin-right': '2px',
  },
  'history-item-original-price-text': {
    display: 'inline-block',
    'text-decoration': 'line-through',
  },
  'other-price-charge-list': {
    'margin-bottom': '5px',
    '&:last-child': {
      'margin-bottom': '10px',
      'padding-bottom': '6px',
      'border-bottom': '1px solid #efefef',
    },
  },
  'other-price-charge-text': {
    display: 'inline-block',
    width: '70px',
    'text-align': 'right',
    'font-size': '12px',
  },
  'other-price-charge-text-label': {
    display: 'inline-block',
    width: '120px',
    'text-align': 'right',
    'font-size': '12px',
  },
  'other-price-charge-span-label': {
    'margin-right': '3px',
  },
  'history-info-wrap': {

  },
  'history-serial-wrap': {
    'text-align': 'left',
    'border-bottom': '1px solid #f5f5f5',
    'padding-bottom': '3px',
  },
  'history-status-wrap': {
    'text-align': 'right',
  },
  'history-serial-label': {
    'margin-right': '3px',
    'font-size': '12px',
  },
  'history-serial-content': {
    'font-size': '12px',
  },
  'history-status-label': {
    'margin-right': '3px',
  },

}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Checkout.js